// @mui material components
import Card from '@mui/material/Card';

// Material Kit 2 React components
import MKBox from 'components/MKBox';
import Footer from 'csdd_components/Footer';
import HomeNavBar from 'csdd_components/HomeNavBar';
import Newsletter from 'csdd_components/Newsletter';

import Profile from 'csdd_components/Profile';
import TopNavBar from 'csdd_components/TopNavBar';
import { useParams } from 'react-router-dom';

function Executive() {
  const { executiveName } = useParams();

  return (
    <>
      <TopNavBar />
      <HomeNavBar />
      <MKBox bgColor='white'>
        <MKBox bgColor='warning' minHeight='25rem' width='100%' />
        <Card
          sx={{
            p: 2,
            mx: { xs: 2, lg: 3 },
            mt: -8,
            mb: 4,
            backgroundColor: ({ palette: { white }, functions: { rgba } }) =>
              rgba(white.main, 0.8),
            backdropFilter: 'saturate(200%) blur(30px)',
            boxShadow: ({ boxShadows: { xxl } }) => xxl,
          }}
        >
          <Profile executiveMember={executiveName} />
        </Card>
        <Newsletter />
        <Footer />
      </MKBox>
    </>
  );
}

export default Executive;
